// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"91fb0991","297":"fcb55d14","643":"3770a3c1"}[chunkId] + ".chunk.js";
};